import React from "react";
import { fromPmAudioAnyState } from "../converters/from-pm-audio-any-state";
import AudioViewer from "../viewer/audio-viewer";
const Audio = ({ settings, node, updateAttributes }) => {
  const { loading } = node.attrs;
  const ricosNode = fromPmAudioAnyState(node);
  return /* @__PURE__ */ React.createElement(
    AudioViewer,
    {
      node: ricosNode,
      updateAttributes,
      settings,
      isLoading: loading
    }
  );
};
export {
  Audio
};
//# sourceMappingURL=component.js.map
